import Spacing from "../../../../src/components/MDX/Spacing";
import PSpacing from "../../../../src/components/MDX/PSpacing";
import Grid2 from "../../../../src/components/MDX/Grid2";
import Summary from "../../../../src/components/MDX/Summary";
import Item from "../../../../src/components/MDX/Item";
import Social from "../../../../src/components/MDX/Social";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaArtstation } from "@react-icons/all-files/fa/FaArtstation";
import PreFooter from "../../../../src/components/MDX/PreFooter";
import * as React from 'react';
export default {
  Spacing,
  PSpacing,
  Grid2,
  Summary,
  Item,
  Social,
  FaInstagram,
  FaArtstation,
  PreFooter,
  React
};